export default __webpack_public_path__ + "static/media/logo.a9bfc4d0.png";